export type TParty = {
    active: boolean;
    address: string | null;
    created_at: number;
    fromSource: string | null;
    id: string;
    industry_count: number;
    name: string;
    party_type: string | null;
    sams_id: number;
}

export type TPagination = {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
}

export type TPartyAPIResponse = {
    data: TParty[];
    done: boolean;
    message: string;
    pagination: TPagination;
}

export type TDomain = {
    domainName: string;
    description: string;
    numberOfChannels: number;
    createdOn: string;
}

export type TFormField = {
    name: string;
    label: string;
    type: 'text' | 'select' | 'textarea' | 'checkbox';
    placeholder?: string;
    options?: Array<{ value: string; label: string }>;
    required?: boolean;
    defaultValue?: string | boolean;
    disabled?: boolean;
}

export type TPDCEDialogProps = {
    id?: string;
    isOpen: boolean;
    onClose: () => void;
    title: string;
    fields: TFormField[];
    onSave: (formData: Record<string, any>) => void;
    onCancel?: () => void;
    saveButtonText?: string;
    cancelButtonText?: string;
    isLoading?: boolean;
}

export type TCreatePartyPayload = {
    name: string;
    address: string;
    party_type: string;
}

export type TCreatePartyResponse = {
    done: boolean;
    id: string;
    message: string;
}

export type TPartyType = {
    created_at: string | null;
    id: number;
    is_active: boolean;
    is_deleted: boolean;
    name: string;
    updated_at: string | null;
}

export type TPartyTypeResponse = {
    data: TPartyType[];
    done: boolean;
}

export const formatDate = (timestamp: number): string => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: '2-digit', 
        year: 'numeric' 
    }).replace(/\s/g, '-').replace(',', '');
}